import React, { useState } from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import IconMenu from "../../components/subMenu/SubMenu";
import { Paper } from "@mui/material";
import { Routes, Route, useParams, useLocation } from "react-router-dom";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Pdf from "../../components/pdf/Pdf";
import { PDFViewer } from "@react-pdf/renderer";
import useSave from "../../Hooks/useSave";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  usePDF,
  PDFDownloadLink,
  Image,
} from "@react-pdf/renderer";
import { useEffect } from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import PackingSlip from "./PackingSlip";

export default function ComleteOrder() {
  const [order, setOrder] = useState();
  const [products, setProducts] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();

  const { fetchGraphql, DialogSave } = useSave();

  const { id } = useParams();

  const groupBy = (items, key) => {
    return items?.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );
  };

  const groupedProducts = groupBy(
    products?.filter((item) => item.combinedId > 0),
    "combinedId"
  );

  console.log(groupedProducts);

  const properties = {
    orderId: id,
  };

  if (location.pathname.includes("challah") || location.pathname.includes("cake")) {
    properties.packingCategory = location.pathname.includes("challah")
      ? "challah"
      : "cake";
  }

  useEffect(() => {
    fetchGraphql({
      query: `query Order($orderId: ID!, $packingCategory: String) {
        order(orderId: $orderId) {
          shippingAddress {
            zip
            state
            city
            addressLine2
            addressLine
            addressId
          }
          billingAddress {
            zip
            state
            addressLine2
            city
            addressLine
            addressId
          }
          customerPhoneNumber
          paymentStatus
          packDate
          orderedVia
          orderStatus
          orderNote
          orderId
          orderDate
          lastEditedBy
          deliveryDate
          customerName
          customerId
          createdBy
        }
        orderProducts(orderId: $orderId, packingCategory: $packingCategory) {
          orderProductId
          orderId
          productId
          productCode
          productName
          productPrice
          priceByPound
          quantity
          packedWeight
          combinedId
          packedQuantity
        }
      }`,
      variables: properties,
    }).then((result) => {
      setOrder(result.data.order);
      setProducts(result.data.orderProducts);
      setIsLoading(false);
    });
  }, []);

  try {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
        }}
      >
        <DialogSave />
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Button
            variant="outlined"
            sx={{ margin: "0px auto 20px 20px" }}
            onClick={() =>
              navigate(
                `/packing/${
                  location.pathname.includes("challah") ? "challah" : "cake"
                }`
              )
            }
          >
            <ArrowBackIcon />
            Back
          </Button>

          <Box sx={{ marginLeft: "auto" }}>
            {!isLoading && (
              <PDFDownloadLink
                document={
                  <PackingSlip
                    location={location}
                    groupedProducts={groupedProducts}
                    products={products?.filter(
                      (item) => !item.combinedId || item.combinedId === "0"
                    )}
                    order={order}
                  />
                }
                fileName={id}
              >
                {({ blob, url, loading, error }) => {
                  return loading ? (
                    <Backdrop
                      sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                      }}
                      open={isLoading}
                      // onClick={handleClose}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  ) : (
                    // "Loading document..."
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();

                        e.preventDefault();

                        const newblob = new Blob([blob], {
                          type: "application/pdf",
                        });

                        const newWindow = window.open(
                          URL.createObjectURL(newblob)
                        );

                        setTimeout(() => newWindow.print(), 1000);
                      }}
                    >
                      Print
                    </Button>
                  );
                }}
              </PDFDownloadLink>
            )}
          </Box>
        </Box>
        {/* <Paper
          sx={{
            width: "100%",
            height: "100%",
            marginLeft: "20px",
            padding: "20px",
            overflow: "auto",
          }}
        > */}

        {isLoading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
            // onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}

        <PDFViewer width="100%" height="100%">
          {!isLoading && (
            <PackingSlip
              location={location}
              groupedProducts={groupedProducts}
              products={products}
              order={order}
            />
          )}
        </PDFViewer>
        {/* </Paper> */}
      </Box>
    );
  } catch (error) {
    console.log(error);
  }
}
